// Get the base URL from environment variable or default
const getBaseUrl = () => {
    // Try to get the API URL from environment variables
    // For Create React App, we use process.env instead of import.meta.env
    
    // let apiUrl = 'https://ebira.rfsteknologi.site/api/v1';
    let apiUrl = 'https://prototype.rfsteknologi.site/api/v1';
    // let apiUrl = 'http://localhost:8000/api/v1'; 
    
    // Remove the /api/v1 part to get the base URL for assets
    return apiUrl.replace('/api/v1', '');
};

/**
 * Get the full URL for an image file
 * @param fileName The name of the image file
 * @param fallbackImage Optional fallback image URL if the file name is invalid
 * @returns The full URL to the image
 */
export const getImageUrl = (fileName: string | undefined, fallbackImage: string = '/placeholder-image.svg') => {
    // If fileName is null, undefined, or empty string, return fallback image
    if (!fileName) {
        return fallbackImage;
    }
    
    // If the filename already starts with http:// or https://, it's already a full URL
    if (fileName.startsWith('http://') || fileName.startsWith('https://')) {
        return fileName;
    }
    
    // Check if we're running on the same domain as the API
    const currentHost = window.location.host;
    const baseUrl = getBaseUrl();
    const baseUrlHost = new URL(baseUrl).host;
    
    // If we're on the same domain, use a relative URL to avoid CORS issues
    if (currentHost === baseUrlHost) {
        return `/uploads/issues/${fileName}`;
    }
    
    // Otherwise use the full URL
    return `${baseUrl}/uploads/issues/${fileName}`;
};

/**
 * Creates an image element with error handling that falls back to a placeholder
 * @param url The URL of the image to load
 * @param fallbackUrl The fallback URL to use if the image fails to load
 * @returns A promise that resolves to the URL that successfully loaded
 */
export const loadImageWithFallback = (url: string, fallbackUrl: string = '/placeholder-image.svg'): Promise<string> => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(url);
        img.onerror = () => {
            console.error(`Failed to load image: ${url}, falling back to: ${fallbackUrl}`);
            resolve(fallbackUrl);
        };
        img.src = url;
    });
};
